import { BadgeCheck } from "lucide-react";

export const ProBadge = ({ size = "md", label = "Pro", className = "", testId = "pro-badge" }) => (
  <span
    data-testid={testId}
    className={`inline-flex items-center rounded-full font-bold uppercase tracking-wider ${
      size === "sm" ? "text-[10px] px-1.5 py-0.5 gap-1" : "text-xs px-2.5 py-1 gap-1.5"
    } bg-blue-50 text-blue-700 border border-blue-200 ${className}`}
  >
    <BadgeCheck size={size === "sm" ? 11 : 13} /> {label}
  </span>
);

export default ProBadge;
